import { MinusIcon, PlusIcon } from '@heroicons/react/outline';
import { CollapseProps } from 'antd';
import clsx from 'clsx';
import { AnimatePresence, motion } from 'framer-motion';
import Head from 'next/head';
import { useRouter } from 'next/router';
import React, { useCallback, useEffect, useState } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';

import PaginatedBookSlider from '@/components/BookComp/PaginatedBookSlider';
import HeroSection from '@/components/PlatformSubscription/HeroSection';
import AutoRenewalModal from '@/components/PlatformSubscription/Modals/AutoRenewalModal';
import PlanTable from '@/components/PlatformSubscription/PlanTable';
import { SubscriptionButtonTitle } from '@/components/PlatformSubscription/PlanTable/Columns';
import ReviewsSection from '@/components/PlatformSubscription/Reviews';
import Values from '@/components/PlatformSubscription/Values';
import { formateErrorObject } from '@/components/shared/formateErrorObject';
import { notify } from '@/components/shared/notify';

import { authModalControl } from '@/atoms/authModalControl';
import appwriteService from '@/config/appwrite';

import { user } from '../../atoms/user';
import SubscriptionModal from '../../components/PlatformSubscription/Modals/SubscriptionModal';
import { pageTitle } from '../../components/shared/basic/customHead';
import { ShouldRender } from '../../components/shared/basic/ShouldRender';
import CustomLoader from '../../components/shared/Loading';
import { plans } from '../../services/Subscribe';
import { IPlan } from '../../utils/interfaces/Subscription';

const PlatformSubscription = () => {
  const router = useRouter();

  const { view } = router.query;
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [, setPlanActiveIndex] = useState<number>(2);
  const [loading, setLoading] = useState<boolean>(true);
  const [plan, setPlan] = useState<IPlan[]>();
  const [selectedPlan, setSelectedPlan] = useState<IPlan>();
  const [, setSelectedIndex] = useState<number>(0);
  const [, setSI] = useState<number>(2);
  const userState = useRecoilValue(user);
  const [isSubModalOpen, setIsSubModalOpen] = useState(false);
  const [isRenewModalOpen, setIsRenewModalOpen] = useState(false);
  const [, setVisible] = useRecoilState(authModalControl);

  // const items: CollapseProps['items'] = [
  //   {
  //     key: '1',
  //     label: 'What subscription plans are available on ZebraLearn?',
  //     children: (
  //       <div className='space-y-4 text-grayZl-500'>
  //         <h1 className='md:text-sm md:font-medium text-xs font-medium'>
  //           ZebraLearn offers three flexible subscription options to suit your
  //           reading preferences:
  //         </h1>
  //         <ul className='list-disc pl-5 space-y-2 md:text-sm text-xs'>
  //           <li>
  //             <h2 className='font-medium'>Digital Only – 3 Months</h2>
  //             <p>Access all digital books for 3 months.</p>
  //           </li>
  //           <li>
  //             <h2 className='font-medium'>Digital Only – 12 Months</h2>
  //             <p>Full-year access to all digital books at a discounted rate.</p>
  //           </li>
  //           <li>
  //             <h2 className='font-medium'>Digital + Physical – 12 Months</h2>
  //             <p>
  //               Get full digital access for 12 months plus selected physical
  //               book deliveries.
  //             </p>
  //           </li>
  //         </ul>
  //       </div>
  //     ),
  //   },
  //   {
  //     key: '2',
  //     label: 'What happens when my digital subscription expires?',
  //     children: (
  //       <div className='space-y-4 text-grayZl-500'>
  //         <h1 className='md:text-sm md:font-medium text-xs font-medium'>
  //           Once your subscription period ends:
  //         </h1>
  //         <ul className='list-disc pl-5 space-y-2 md:text-sm text-xs'>
  //           <li>You will lose access to previously unlocked digital books.</li>
  //           <li>
  //             To retain access to your digital library, please renew before the
  //             expiry date.
  //           </li>
  //           <li>
  //             Renewing after expiry may result in resetting your access history.
  //           </li>
  //         </ul>
  //       </div>
  //     ),
  //   },
  //   {
  //     key: '3',
  //     label: 'What’s included in the “Digital + Physical” plan?',
  //     children: (
  //       <div className='space-y-4 text-grayZl-500'>
  //         <h1 className='md:text-sm md:font-medium text-xs font-medium'>
  //           This plan offers:
  //         </h1>
  //         <ul className='list-disc pl-5 space-y-2 md:text-sm text-xs'>
  //           <li>Unlimited access to all digital books for 12 months.</li>
  //           <li>
  //             Monthly delivery of selected physical books (based on plan terms).
  //           </li>
  //           <li>Priority customer support and early access to new releases.</li>
  //         </ul>
  //       </div>
  //     ),
  //   },
  //   {
  //     key: '4',
  //     label: 'Can I upgrade my plan after purchase?',
  //     children: (
  //       <p className='text-grayZl-500'>
  //         Yes. You can upgrade from a 3-month to a 12-month plan, or from
  //         Digital Only to Digital + Physical by paying the price difference. The
  //         new plan will start immediately upon upgrade.
  //       </p>
  //     ),
  //   },
  //   {
  //     key: '5',
  //     label: 'What happens if I cancel mid-way through my plan?',
  //     children: (
  //       <ul className='list-disc pl-5 text-grayZl-500 space-y-2'>
  //         <li>Subscription fees are non-refundable.</li>
  //         <li>
  //           You will continue to have access until your current plan expires.
  //         </li>
  //         <li>For any billing concerns, reach out to our support team.</li>
  //       </ul>
  //     ),
  //   },
  //   {
  //     key: '6',
  //     label: 'Is the subscription auto-renewed?',
  //     children: (
  //       <p className='text-grayZl-500'>
  //         You will receive reminders via email/app notifications before expiry
  //         so you can renew manually.
  //       </p>
  //     ),
  //   },
  //   {
  //     key: '7',
  //     label:
  //       'Will I retain my reading progress and highlights if I renew late?',
  //     children: (
  //       <ul className='list-disc pl-5 text-grayZl-500 space-y-2'>
  //         <li>
  //           If you renew before the due date, all reading history, notes, and
  //           highlights are preserved.
  //         </li>
  //         <li>
  //           Delayed renewals may cause temporary loss of reading data, which may
  //           not be fully restored.
  //         </li>
  //       </ul>
  //     ),
  //   },
  //   {
  //     key: '8',
  //     label: 'Can I access my books on multiple devices?',
  //     children: (
  //       <p className='text-grayZl-500'>
  //         Yes. Your ZebraLearn subscription allows access on multiple devices
  //         (web, Android, and iOS). Just log in with your account.
  //       </p>
  //     ),
  //   },
  // ];
  const items: CollapseProps['items'] = [
    {
      key: '1',
      label: 'What subscription plans are available?',
      children: (
        <div className='space-y-4 text-grayZl-500'>
          <p>We offer two simple plans:</p>
          <ul className='list-disc pl-5 space-y-2 md:text-sm text-xs'>
            <li>1-Month Plan – Full access to all books for 30 days</li>
            <li>12-Month Plan – Full access for 365 days</li>
          </ul>
        </div>
      ),
    },
    {
      key: '2',
      label: 'Do I get full access to all books?',
      children: (
        <p className='text-grayZl-500'>
          Yes.
          <br />
          With an active subscription, every book on the platform is 100% free
          to read—no extra charges, no limits.
        </p>
      ),
    },
    {
      key: '3',
      label: 'What is included in my subscription?',
      children: (
        <div className='space-y-2 text-grayZl-500'>
          <p>Your subscription gives you:</p>
          <ul className='list-disc pl-5 space-y-2 md:text-sm text-xs'>
            <li>Unlimited reading of all books</li>
            <li>Access to all new books added during your plan</li>
            <li>Full platform features throughout your plan duration</li>
          </ul>
        </div>
      ),
    },
    {
      key: '4',
      label: 'How does the subscription duration work?',
      children: (
        <div className='space-y-2 text-grayZl-500'>
          <p>
            Your access remains active for the full duration of your selected
            plan:
          </p>
          <ul className='list-disc pl-5 space-y-2 md:text-sm text-xs'>
            <li>1-Month Plan: 30 days</li>
            <li>12-Month Plan: 365 days</li>
          </ul>
          <p>During this period, you can read as many books as you want.</p>
        </div>
      ),
    },
    {
      key: '5',
      label: 'Will my plan auto-renew?',
      children: (
        <p className='text-grayZl-500'>
          Yes, both plans automatically renew to ensure uninterrupted access.
          <br />
          You can turn off auto-renew anytime from your account settings.
        </p>
      ),
    },
    {
      key: '6',
      label: 'Can I cancel my subscription?',
      children: (
        <div className='space-y-2 text-grayZl-500'>
          <p>Yes, you can cancel anytime.</p>
          <p>After cancelling:</p>
          <ul className='list-disc pl-5 space-y-2 md:text-sm text-xs'>
            <li>
              You will not be charged again unless you choose to restart your
              subscription
            </li>
          </ul>
        </div>
      ),
    },
    {
      key: '7',
      label: 'Are subscription payments refundable?',
      children: (
        <p className='text-grayZl-500'>
          No, subscription fees are non-refundable, but your access continues
          until the end of your active plan.
        </p>
      ),
    },
    {
      key: '8',
      label: 'What happens when my subscription ends?',
      children: (
        <div className='space-y-2 text-grayZl-500'>
          <p>If auto-renew is ON → your plan renews automatically</p>
          <p>If auto-renew is OFF → your access to books will stop</p>
          <p>You can resubscribe anytime to regain full access.</p>
        </div>
      ),
    },
    {
      key: '9',
      label: 'Will I lose my reading progress if my subscription ends?',
      children: (
        <p className='text-grayZl-500'>
          Yes. Your progress and saved books are removed. When you subscribe
          again, everything resumes from where you left off.
        </p>
      ),
    },
  ];

  const subscriptionHandle = async (buttonTitle: SubscriptionButtonTitle) => {
    try {
      if (buttonTitle === SubscriptionButtonTitle.Cancel) {
        return setIsRenewModalOpen(true);
      }

      const loggedInStatus = await appwriteService.isLoggedIn();
      if (!loggedInStatus) {
        return setVisible((prevState) => ({
          ...prevState,
          signUp: true,
          noRedirect: true,
        }));
      }

      setIsSubModalOpen(true);
    } catch (error: any) {
      notify(formateErrorObject(error), 'error');
    }
  };

  const plansHandle = async () => {
    try {
      setLoading(true);
      const result = await plans({ type: 'platform', group_name: 'main' });
      setPlan(result.data);
      setSelectedPlan(result.data[result?.data?.length - 1]);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const toggleAccordion = useCallback(
    (index: number) => {
      setActiveIndex(activeIndex === index ? -1 : index);
    },
    [activeIndex],
  );

  // const togglePlan = useCallback(
  //   (index: number) => {
  //     setPlanActiveIndex(planActiveIndex === index ? -1 : index);
  //   },
  //   [planActiveIndex],
  // );

  // const options = [
  //   SubscriptionParametersEnum.TOTAL_SUBSCRIPTION_DURATION,
  //   SubscriptionParametersEnum.BOOKS_QUANTITY,
  //   SubscriptionParametersEnum.DIGITAL_BOOKS,
  //   SubscriptionParametersEnum.HARDCOVER_BOOKS,
  //   SubscriptionParametersEnum.HIDDEN_CHARGES,
  //   SubscriptionParametersEnum.SHIPPING_CHARGES,
  //   SubscriptionParametersEnum.APP_AND_WEB_FRIENDLY,
  //   '',
  // ];

  // const tableContent = options.filter(() => {
  //   // if (i === '' && userState?.subscription?.id) {
  //   //   return false;
  //   // }

  //   return true;
  // });

  useEffect(() => {
    plansHandle();
  }, []);

  useEffect(() => {
    const planIndex = plan?.findIndex(
      (i) => i.id === userState?.subscription?.plan_id,
    );
    if (plan && planIndex && planIndex >= 0) {
      setSelectedIndex(plan.length - 1 - planIndex);
      setPlanActiveIndex(planIndex);
      setSI(planIndex);
    }
  }, [userState, plan]);

  return (
    <div>
      <Head>
        <title>{pageTitle('Subscribe')}</title>
      </Head>
      <HeroSection />
      <ShouldRender check={!loading}>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className=' mx-auto md:max-w-screen-md lg:max-w-screen-lg xl:max-w-7xl'
        >
          <PlanTable
            subscriptionHandle={subscriptionHandle}
            setSelectedPlan={setSelectedPlan}
            plans={plan}
          />

          {/* <div className='md:block hidden lg:mx-10 md:mx-0 relative my-10'>
            <table className='relative w-full z-20'>
              <thead>
                <tr>
                  <td>
                    <div>
                      <p className='text-white xl:text-4xl lg:text-4xl md:text-2xl font-semibold leading-[44px] tracking-[-0.9px] mb-3 mt-12'>
                        Choose a Subscription
                      </p>
                      <p className='2xl:text-base/6 xl:text-base/6 lg:text-base/6 md:text-sm/6 font-normal text-grayZl-500 mb-10'>
                        All membership plan come with a price and content
                        <br />
                        satisfaction guarantee.{' '}
                      </p>
                      <div className='w-10 h-1 bg-primary mb-9' />
                    </div>
                  </td>

                  {plan?.map((pn, index) => (
                    <td
                      className='w-[200px] min-w-[200px] max-w-[200px]'
                      key={`${pn.id}-${index}`}
                    >
                      <div className='flex flex-col items-center'>
                        {pn.name === 'Standard' ? (
                          userState?.subscription?.plan_id === pn.id ? (
                            <ExpireBadge
                              classes={{
                                parantClass: 'xl:mt-[39px]  md:mt-[39px] mb-4',
                              }}
                              title={`Expires in ${moment(userState.subscription.expired_at).diff(moment(), 'days')} days`}
                            />
                          ) : (
                            <LimitedTimeBadge
                              classes={{
                                parantClass: 'xl:mt-[39px]  md:mt-[39px] mb-4',
                              }}
                            />
                          )
                        ) : pn.name === 'Premium' ? (
                          userState?.subscription?.plan_id === pn.id ? (
                            <ExpireBadge
                              classes={{
                                parantClass:
                                  'xl:mt-[39px] md:mx-1 md:mt-[39px] mb-4',
                              }}
                              title={`Expires in ${moment(userState.subscription.expired_at).diff(moment(), 'days')} days`}
                            />
                          ) : (
                            <BestValueBadge
                              classes={{
                                parantClass:
                                  'xl:mx-8 xl:mt-[39px] md:mx-1 md:mt-[39px] mb-4',
                              }}
                            />
                          )
                        ) : userState?.subscription?.plan_id === pn.id ? (
                          <ExpireBadge
                            classes={{
                              parantClass: 'xl:mt-[39px]  md:mt-[39px] mb-4',
                            }}
                            title={`Expires in ${moment(userState.subscription.expired_at).diff(moment(), 'days')} days`}
                          />
                        ) : (
                          <div className='bg-success-950 rounded-full xl:mx-8 xl:mt-[39px] md:mx-1 md:mt-[39px] px-2.5 py-[5px] mb-4 invisible'>
                            <p className='2xl:text-sm xl:text-sm lg:text-sm  md:text-[10px] 2xl:font-semibold xl:font-semibold lg:font-semibold  md:font-medium leading-[22px] text-success-400 line-clamp-1'>
                              Limited Time Deal
                            </p>
                          </div>
                        )}

                        <p className='text-base/6 text-white font-normal mb-4 capitalize'>
                          {pn.name}
                        </p>
                        <div className='flex items-start gap-1 mb-4'>
                          <p className='text-grayZl-500 text-base leading-[29px]'>
                            ₹
                          </p>
                          <p className='text-2xl/10 tracking-[-0.8px] font-semibold'>
                            {pn.razorpay_plan.amount / 100}
                          </p>
                        </div>
                        {userState?.subscription?.plan_id === pn.id ? (
                          <ButtonDefault
                            variant={ButtonVariants.PRIMARY}
                            size={0}
                            onClick={() => {
                              setSelectedPlan(pn);
                              setSelectedIndex(plan.length - (index + 1));
                              setSI(index);
                            }}
                            roundedUnstyled
                            className='font-medium mb-4 2xl:px-4 xl:px-4 lg:px-4 md:px-4  2xl:py-[9px]  xl:py-[9px]  lg:py-[9px]  md:py-[9px] text-sm leading-[22px] rounded-lg active:scale-95 hover:scale-105 transition-transform capitalize'
                          >
                            Currently Subscribed
                          </ButtonDefault>
                        ) : (
                          <ButtonDefault
                            // disabled={
                            //   userState?.subscription?.plan_id ? true : false
                            // }
                            variant={ButtonVariants.UNSTYLED}
                            size={0}
                            roundedUnstyled
                            onClick={() => {
                              setSelectedPlan(pn);
                              setSelectedIndex(plan.length - (index + 1));
                              setSI(index);
                            }}
                            className={`
                              ${sI === index ? 'bg-white text-black' : ''}
                              font-medium mb-4 2xl:px-[38px] xl:px-[38px] lg:px-[38px] md:px-[28px]  2xl:py-[9px]  xl:py-[9px]  lg:py-[9px]  md:py-[9px] text-sm leading-[22px] border  rounded-lg active:scale-95 hover:scale-105 transition-transform capitalize`}
                          >
                            {sI === index
                              ? 'selected'
                              : isSubscriptionActive(userState)
                                ? 'Change Plan'
                                : 'Select'}
                          </ButtonDefault>
                        )}
                      </div>
                    </td>
                  ))}
                </tr>
              </thead>
              <tbody>
                {tableContent.map((item, index) => (
                  <tr
                    key={`${item}-${index}`}
                    className={`
                ${tableContent.length - 1 === index ? '' : 'border-b border-grayZl-900'}
                `}
                  >
                    <td>
                      <div className='py-[17px]'>
                        <p className='text-sm leading-[22px] font-medium text-white'>
                          {item}
                        </p>
                      </div>
                    </td>
                    {}
                    {item ===
                      SubscriptionParametersEnum.TOTAL_SUBSCRIPTION_DURATION &&
                      plan?.map((pn) => (
                        <td key={`${pn.id}-${index}`}>
                          <div className='py-[17px]'>
                            <p className='text-sm leading-[22px] font-medium text-white text-center'>
                              {pn.periodicity}
                              {pn.periodicity_type === 'monthly'
                                ? ' Months'
                                : ''}
                            </p>
                          </div>
                        </td>
                      ))}
                    {item === SubscriptionParametersEnum.BOOKS_QUANTITY &&
                      plan?.map((pn) => (
                        <td key={`${pn.id}-${index}`}>
                          <div className='py-[17px]'>
                            <p className='text-sm leading-[22px] font-medium text-white text-center'>
                              {pn.features[0]?.quota}
                              {pn.features[0]?.name === 'products'
                                ? ' Book/'
                                : ''}
                              {pn.features[0]?.periodicity_type}
                            </p>
                          </div>
                        </td>
                      ))}
                    {item === SubscriptionParametersEnum.DIGITAL_BOOKS &&
                      plan?.map((pn) => (
                        <td key={`${pn.id}-${index}`}>
                          {pn.rules[0]?.digital && (
                            <div className='py-[17px] flex items-center justify-center'>
                              <CheckIcon className='w-[22px] h-[22px] text-success-400' />
                            </div>
                          )}
                        </td>
                      ))}
                    {item === SubscriptionParametersEnum.HARDCOVER_BOOKS &&
                      plan?.map((pn) => (
                        <td key={`${pn.id}-${index}`}>
                          {pn.rules[0]?.physical ? (
                            <div className='py-[17px] flex items-center justify-center'>
                              <CheckIcon className='w-[22px] h-[22px] text-success-400' />
                            </div>
                          ) : (
                            <div className='py-[17px] flex items-center justify-center'>
                              <XIcon className='w-[22px] h-[22px] text-error-400' />
                            </div>
                          )}
                        </td>
                      ))}

                    {item === SubscriptionParametersEnum.HIDDEN_CHARGES &&
                      plan?.map((pn) => (
                        <td key={`${pn.id}-${index}`}>
                          <div className='py-[17px]'>
                            <p className='text-sm leading-[22px] font-medium text-white text-center'>
                              No Hidden Charges
                            </p>
                          </div>
                        </td>
                      ))}
                    {item === SubscriptionParametersEnum.SHIPPING_CHARGES &&
                      plan?.map((pn) => (
                        <td key={`${pn.id}-${index}`}>
                          <div className='py-[17px]'>
                            {pn.rules[0]?.physical ? (
                              <p className='text-sm leading-[22px] font-medium text-white text-center'>
                                Included
                              </p>
                            ) : (
                              <p className='text-sm leading-[22px] font-medium text-white text-center'>
                                None
                              </p>
                            )}
                          </div>
                        </td>
                      ))}

                    {item === SubscriptionParametersEnum.APP_AND_WEB_FRIENDLY &&
                      plan?.map((pn) => (
                        <td key={`${pn.id}-${index}`}>
                          <div className='py-[17px] flex items-center justify-center'>
                            <CheckIcon className='w-[22px] h-[22px] text-success-400' />
                          </div>
                        </td>
                      ))}

                    {item === '' && (
                      <>
                        {Array(sI)
                          .fill(0)
                          .map((_i, index) => (
                            <td key={index}></td>
                          ))}
                        <td>
                          <div
                            className={`
                            ${
                              sI !== undefined &&
                              plan?.[sI]?.id !==
                                userState?.subscription?.plan_id
                                ? 'visible'
                                : 'invisible'
                            }
                            p-[15px]`}
                          >
                            <ButtonDefault
                              variant={ButtonVariants.PRIMARY}
                              size={0}
                              roundedUnstyled
                              onClick={subscriptionHandle}
                              className=' active:scale-95 hover:scale-105 transition-transform  p-2.5 rounded-lg w-full text-white text-sm leading-[22px] font-medium flex items-center justify-center gap-2'
                            >
                              Subscribe
                            </ButtonDefault>
                          </div>
                        </td>
                      </>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
            <div className='z-10 absolute top-0 left-0 w-full h-full flex justify-end'>
              <div className='relative top-0 left-0 w-full h-full'>
                <div
                  style={{
                    width: tdWidth + 'px',
                    right: tdWidth * selectedIndex + 'px',
                  }}
                  className='transition-all duration-300 ease-in-out absolute top-0 h-full bg-gradient-to-b from-[rgba(199,97,7,0.2)] to-[rgba(69,35,5,0.2)] border border-white/10 rounded-lg'
                ></div>
              </div>
            </div>
          </div>

          <div className='block md:hidden'>
            {plan?.map((pn, index) => (
              <motion.div
                key={`${pn.id}-${index}`}
                className={clsx(
                  planActiveIndex === index
                    ? 'bg-gradient-to-b from-[rgba(199,97,7,0.2)] to-[rgba(69,35,5,0.2)]'
                    : 'bg-black',
                  'overflow-hidden flex flex-col ',
                  plan.length === index + 1 ? '' : 'border-b border-grayZl-850',
                )}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 + 0.2 }}
              >
                <motion.button
                  className='flex flex-col gap-3 m-4'
                  onClick={() => {
                    togglePlan(index);
                    setSelectedPlan(pn);
                  }}
                  // whileHover={{
                  //   backgroundColor: 'rgba(40, 40, 41, 0.5)',
                  // }}
                >
                  <div className='flex justify-between items-center'>
                    <div className='flex items-center gap-3'>
                      <p className='text-base/6 font-normal capitalize'>
                        {pn.name}
                      </p>

                      {pn.name === 'Standard' ? (
                        userState?.subscription?.plan_id === pn.id ? (
                          <ExpireBadge
                            classes={{
                              parantClass: 'px-2.5 py-1 ',
                              textClass: 'text-xs/3 font-medium line-clamp-1',
                            }}
                            title={`Expires in ${moment(userState.subscription.expired_at).diff(moment(), 'days')} days`}
                          />
                        ) : (
                          <div className='bg-success-950 rounded-full px-2.5 py-1 '>
                            <p className=' text-xs/3 font-medium text-success-400 line-clamp-1'>
                              Limited Time Deal
                            </p>
                          </div>
                        )
                      ) : pn.name === 'Premium' ? (
                        userState?.subscription?.plan_id === pn.id ? (
                          <ExpireBadge
                            classes={{
                              parantClass: 'px-2.5 py-1 ',
                              textClass: 'text-xs/3 font-medium line-clamp-1',
                            }}
                            title={`Expires in ${moment(userState.subscription.expired_at).diff(moment(), 'days')} days`}
                          />
                        ) : (
                          <div className='bg-gradient-to-b from-[#F9742C] to-[#F20486] rounded-full flex items-center justify-center'>
                            <div className='w-full h-full m-[1.5px] rounded-full bg-[#280e03] px-2.5 py-1'>
                              <p className='text-xs/3 font-medium text-white'>
                                % Best Value
                              </p>
                            </div>
                          </div>
                        )
                      ) : userState?.subscription?.plan_id === pn.id ? (
                        <ExpireBadge
                          classes={{
                            parantClass: 'px-2.5 py-1 ',
                            textClass: 'text-xs/3 font-medium line-clamp-1',
                          }}
                          title={`Expires in ${moment(userState.subscription.expired_at).diff(moment(), 'days')} days`}
                        />
                      ) : (
                        <div className='bg-success-950 rounded-full px-2.5 py-1 invisible'>
                          <p className=' text-xs/3 font-medium text-success-400 line-clamp-1'>
                            Limited Time Deal
                          </p>
                        </div>
                      )}
                    </div>
                    <motion.div
                      animate={{
                        rotate: planActiveIndex === index ? -180 : 0,
                      }}
                      transition={{ duration: 0.2 }}
                    >
                      <ChevronDownIcon className='h-4 w-4  text-white' />
                    </motion.div>
                  </div>
                  <div className='flex items-start gap-1'>
                    <p className='text-grayZl-500 text-base leading-[29px]'>
                      ₹
                    </p>
                    <p className='text-4xl/10 tracking-[-0.8px] font-semibold'>
                      {pn.razorpay_plan.amount / 100}
                    </p>
                  </div>
                </motion.button>

                <AnimatePresence>
                  {planActiveIndex === index && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: 'auto', opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{
                        duration: 0.3,
                        ease: 'easeInOut',
                      }}
                      className='overflow-hidden'
                    >
                      <div className='flex'>
                        <ButtonDefault
                          disabled={userState?.subscription?.plan_id === pn?.id}
                          variant={ButtonVariants.PRIMARY}
                          size={0}
                          onClick={() => {
                            setSelectedPlan(pn);
                            subscriptionHandle();
                          }}
                          roundedUnstyled
                          className='disabled:bg-primary disabled:text-white disabled:opacity-90 w-full mx-4 mb-4 px-6 py-[9px] text-white font-normal text-sm rounded-lg  hover:scale-105 active:scale-95 transition-transform'
                        >
                          {userState?.subscription?.plan_id === pn?.id
                            ? 'Currently Subscribed'
                            : isSubscriptionActive(userState)
                              ? 'Change Plan'
                              : 'Subscribe'}
                        </ButtonDefault>
                      </div>
                      <div className='flex flex-col'>
                        {tableContent.map(
                          (item, index) =>
                            item && (
                              <div
                                key={`table-${item}-${index}`}
                                className='flex'
                              >
                                <div className='flex-1 px-4 py-3.5'>
                                  <p className='text-xs/5'>{item}</p>
                                </div>
                                <div className='flex-1'>
                                  {item ===
                                    SubscriptionParametersEnum.TOTAL_SUBSCRIPTION_DURATION &&
                                    plan
                                      ?.filter(
                                        (pn) => selectedPlan?.id === pn.id,
                                      )
                                      .map((pn) => (
                                        <div
                                          className='px-4 py-3.5'
                                          key={`total-${item}-${index}-${pn.id}`}
                                        >
                                          <div>
                                            <p className='text-xs/5 font-medium text-white text-end'>
                                              {pn.periodicity}
                                              {pn.periodicity_type === 'monthly'
                                                ? ' Months'
                                                : ''}
                                            </p>
                                          </div>
                                        </div>
                                      ))}

                                  {item ===
                                    SubscriptionParametersEnum.BOOKS_QUANTITY &&
                                    plan
                                      ?.filter(
                                        (pn) => selectedPlan?.id === pn.id,
                                      )
                                      .map((pn) => (
                                        <div
                                          className='px-4 py-3.5'
                                          key={`books-${item}-${index}-${pn.id}`}
                                        >
                                          <div>
                                            <p className='text-xs/5 font-medium text-white text-end'>
                                              {pn.features[0]?.quota}
                                              {pn.features[0]?.name ===
                                              'products'
                                                ? ' Book/'
                                                : ''}
                                              {pn.features[0]?.periodicity_type}
                                            </p>
                                          </div>
                                        </div>
                                      ))}

                                  {item ===
                                    SubscriptionParametersEnum.DIGITAL_BOOKS &&
                                    plan
                                      ?.filter(
                                        (pn) => selectedPlan?.id === pn.id,
                                      )
                                      .map((pn) => (
                                        <div
                                          className='px-4 py-3.5'
                                          key={`digital-${item}-${index}-${pn.id}`}
                                        >
                                          {pn.rules[0]?.digital && (
                                            <div className=' flex items-center justify-end'>
                                              <CheckIcon className='w-5 h-5 text-success-400' />
                                            </div>
                                          )}
                                        </div>
                                      ))}

                                  {item ===
                                    SubscriptionParametersEnum.HARDCOVER_BOOKS &&
                                    plan
                                      ?.filter(
                                        (pn) => selectedPlan?.id === pn.id,
                                      )
                                      .map((pn) => (
                                        <div
                                          className='px-4 py-3.5'
                                          key={`hardcover-${item}-${index}-${pn.id}`}
                                        >
                                          {pn.rules[0]?.physical ? (
                                            <div className=' flex items-center justify-end'>
                                              <CheckIcon className='w-5 h-5 text-success-400' />
                                            </div>
                                          ) : (
                                            <div className=' flex items-center justify-end'>
                                              <XIcon className='w-5 h-5 text-error-400' />
                                            </div>
                                          )}
                                        </div>
                                      ))}

                                  {item ===
                                    SubscriptionParametersEnum.HIDDEN_CHARGES &&
                                    plan
                                      ?.filter(
                                        (pn) => selectedPlan?.id === pn.id,
                                      )
                                      .map((pn) => (
                                        <div
                                          className='px-4 py-3.5'
                                          key={`hidden-${item}-${index}-${pn.id}`}
                                        >
                                          <div>
                                            <p className='text-xs/5 font-medium text-white text-end'>
                                              No Hidden Charges
                                            </p>
                                          </div>
                                        </div>
                                      ))}

                                  {item ===
                                    SubscriptionParametersEnum.SHIPPING_CHARGES &&
                                    plan
                                      ?.filter(
                                        (pn) => selectedPlan?.id === pn.id,
                                      )
                                      .map((pn) => (
                                        <div
                                          className='px-4 py-3.5'
                                          key={`shipping-${item}-${index}-${pn.id}`}
                                        >
                                          <div>
                                            {pn.rules[0]?.physical ? (
                                              <p className='text-xs/5 font-medium text-white text-end'>
                                                Included
                                              </p>
                                            ) : (
                                              <p className='text-xs/5 font-medium text-white text-end'>
                                                None
                                              </p>
                                            )}
                                          </div>
                                        </div>
                                      ))}

                                  {item ===
                                    SubscriptionParametersEnum.APP_AND_WEB_FRIENDLY &&
                                    plan
                                      ?.filter(
                                        (pn) => selectedPlan?.id === pn.id,
                                      )
                                      .map((pn) => (
                                        <div
                                          className='px-4 py-3.5'
                                          key={`appweb-${item}-${index}-${pn.id}`}
                                        >
                                          <div className=' flex items-center justify-end'>
                                            <CheckIcon className='w-5 h-5 text-success-400' />
                                          </div>
                                        </div>
                                      ))}
                                </div>
                              </div>
                            ),
                        )}
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            ))}
          </div> */}
          <div className='md:py-16 py-8'>
            <PaginatedBookSlider
              categoryId={null}
              categoryName='Top 10 Books of all time'
              // subHeadingCol={
              //   screens.md
              //     ? 'These books are our bestsellers of all time. Customers loved these books.'
              //     : 'These books are our bestsellers of all time.'
              // }
              isTopTen={true}
              hideShortBook={view?.toString() === 'cred'}
            />
            <PaginatedBookSlider
              categoryId={
                process.env.NEXT_PUBLIC_APP_ENV === 'staging'
                  ? '6634d1935c4cf495a9c52232'
                  : '6630ef434d8718482ab83ade'
              }
              categoryName='Finance'
              // subHeadingCol={
              //   screens.md
              //     ? 'These books are our bestsellers of all time. Customers loved these books.'
              //     : 'These books are our bestsellers of all time.'
              // }
              hideShortBook={view?.toString() === 'cred'}
            />
            <PaginatedBookSlider
              categoryId={
                process.env.NEXT_PUBLIC_APP_ENV === 'staging'
                  ? '6634d1745c4cf495a9c52209'
                  : '6630eef5c5f62d6df24ca7e8'
              }
              categoryName='Business'
              // subHeadingCol={
              //   screens.md
              //     ? 'These books are our bestsellers of all time. Customers loved these books.'
              //     : 'These books are our bestsellers of all time.'
              // }
              hideShortBook={view?.toString() === 'cred'}
            />
            <PaginatedBookSlider
              categoryId={
                process.env.NEXT_PUBLIC_APP_ENV === 'staging'
                  ? '6634d1105c4cf495a9c5213d'
                  : '6630ef444d8718482ab83ae0'
              }
              categoryName='Marketing'
              // subHeadingCol={
              //   screens.md
              //     ? 'These books are our bestsellers of all time. Customers loved these books.'
              //     : 'These books are our bestsellers of all time.'
              // }
              hideShortBook={view?.toString() === 'cred'}
            />
          </div>
          <Values />
          <ReviewsSection />

          <div className='mx-3 py-16 '>
            <p className='md:text-[32px] text-xl leading-[40px] font-semibold text-white md:mb-4 mb-0 text-left'>
              Frequently Asked Questions
            </p>
            <p className=' md:text-lg text-sm md:leading-[26px] leading-5  text-grayZl-400 text-left mb-12'>
              Everything you need to know about the product and billing.
            </p>
            <div className='flex flex-col gap-3 w-full'>
              {items.map((item, index) => (
                <motion.div
                  key={index}
                  className={clsx(
                    activeIndex === index ? 'bg-[#282829]' : 'bg-[#1C1C1C]',
                    'rounded-[8px] sm:rounded-[10px] overflow-hidden',
                  )}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 + 0.2 }}
                >
                  <motion.button
                    className='w-full flex items-center justify-between px-3 sm:px-4 md:px-4 lg:px-6 py-3 sm:py-3 md:py-3 lg:py-5 text-left text-white gap-5'
                    onClick={() => toggleAccordion(index)}
                  // whileHover={{
                  //   backgroundColor: 'rgba(40, 40, 41, 0.5)',
                  // }}
                  >
                    <span className='text-sm md:text-base/6 md:font-semibold font-medium'>
                      {item.label}
                    </span>
                    <motion.div
                      // animate={{
                      //   rotate: activeIndex === index ? 45 : 0,
                      // }}
                      transition={{ duration: 0.2 }}
                    >
                      {activeIndex === index ? (
                        <MinusIcon className='h-3 w-3 sm:h-4 sm:w-4 md:h-5 md:w-4 text-white' />
                      ) : (
                        <PlusIcon className='h-3 w-3 sm:h-4 sm:w-4 md:h-5 md:w-4 text-[#FFFFFF99]' />
                      )}
                    </motion.div>
                  </motion.button>

                  <AnimatePresence>
                    {activeIndex === index && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: 'auto', opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{
                          duration: 0.3,
                          ease: 'easeInOut',
                        }}
                        className='overflow-hidden'
                      >
                        <div className='px-4 sm:px-4 md:px-4 lg:px-6 py-3 sm:pb-3 md:pb-3 lg:pb-5 pt-0 text-sm md:text-xs lg:text-sm/6 font-normal text-grayZl-500'>
                          {item.children}
                        </div>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </motion.div>
              ))}
            </div>
          </div>
        </motion.div>
      </ShouldRender>
      <ShouldRender check={loading}>
        <CustomLoader />
      </ShouldRender>
      <SubscriptionModal
        plan={selectedPlan}
        open={isSubModalOpen}
        setOpen={setIsSubModalOpen}
      />
      <AutoRenewalModal
        plan={selectedPlan}
        open={isRenewModalOpen}
        setOpen={setIsRenewModalOpen}
      />
    </div>
  );
};

export default PlatformSubscription;
